module.exports = "/assets/5608938974ff135bdcb71ed8e4274ad5.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/EW.png
// module id = 1351
// module chunks = 0